export const FORMULA_SPHERE_NAME = 'sphere'
export const FORMULA_CYLINDER_NAME = 'cylinder'
export const FORMULA_AXIS_NAME = 'axis'
export const FORMULA_ADDICTION_NAME = 'addiction'

const FORMULA_ITEM_NAME = {
  [FORMULA_SPHERE_NAME]: 'Esfera',
  [FORMULA_CYLINDER_NAME]: 'Cilindro',
  [FORMULA_AXIS_NAME]: 'Eje',
  [FORMULA_ADDICTION_NAME]: 'Adición'
}

export function getFormulaItemName (name) {
  return FORMULA_ITEM_NAME[name] ? FORMULA_ITEM_NAME[name] : name
}

export function getFormulaValue (value, decimals) {
  if (value === 0) {
    return parseFloat(value)
  }

  return parseFloat(value).toFixed(decimals)
}

export function buildFormulaValues (min, max, interval, decimals, handlesPrefix) {
  if (isNaN(min) || isNaN(max)) {
    return []
  }

  const result = []

  let currentPosition = min
  while (currentPosition <= max) {
    const prefix = handlesPrefix && currentPosition > 0 ? '+' : ''
    const value = getFormulaValue(currentPosition, decimals)

    result.push({
      key: parseFloat(value),
      name: prefix + value
    })

    currentPosition += interval
  }

  return result
}

export function buildFormulaData (formulaInput) {
  const formula = []

  for (const name in formulaInput) {
    const value = formulaInput[name]
    if (!value && value !== 0) {
      continue
    }

    formula.push({ name, value })
  }

  return formula
}
